"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var StackView_1 = require("../../../StackView");
var View_1 = require("../../../View");
var Icon_1 = require("../../../Icon");
var Text_1 = require("../../../Text");
var Tooltip_1 = require("../../../Tooltip");
var helpers_1 = require("../../../Grid/cellRenderers/helpers");
var helpers_2 = require("../helpers");
function getValueTextColor(_a) {
    var disabled = _a.disabled, isPlaceholder = _a.isPlaceholder;
    if (disabled || isPlaceholder) {
        return Text_1.TEXT_VIEW.light;
    }
    return Text_1.TEXT_VIEW.primary;
}
exports.getValueTextColor = getValueTextColor;
var TextWithTooltip = function (_a) {
    var disabled = _a.disabled, text = _a.text, isPlaceholder = _a.isPlaceholder;
    var ref = react_1.useRef(null);
    return Tooltip_1.useTooltip({
        maxWidth: helpers_2.DEFAULT_MAX_WIDTH_COMBOBOX_TOOLTIP,
        renderContent: function () { return react_1.default.createElement(helpers_1.TooltipText, { size: Text_1.TEXT_SIZE.s }, text); },
        render: function (tooltipProps) {
            return (react_1.default.createElement(Text_1.Text, __assign({}, tooltipProps, { ref: ref, view: getValueTextColor({ disabled: disabled, isPlaceholder: isPlaceholder }), truncate: true, onMouseEnter: helpers_1.onMouseEnterHandlerDecorator(tooltipProps.onMouseEnter, ref), onMouseLeave: tooltipProps.onMouseLeave }), text));
        }
    });
};
function defaultValueRenderer(_a) {
    var icon = _a.icon, disabled = _a.disabled, placeholder = _a.placeholder, formattedText = _a.formattedText, value = _a.value;
    var displayPlaceholder = !!placeholder && (!value || value === 0);
    return (react_1.default.createElement(StackView_1.StackView, { testId: "combobox-value", align: StackView_1.STACK_ALIGN.center, spaceFill: View_1.SPACE_FILL.all, gap: StackView_1.STACK_GAP.s },
        icon && react_1.default.createElement(Icon_1.Icon, { src: icon, disabled: disabled }),
        react_1.default.createElement(TextWithTooltip, { text: displayPlaceholder ? placeholder : formattedText, isPlaceholder: displayPlaceholder, disabled: disabled })));
}
exports.defaultValueRenderer = defaultValueRenderer;
//# sourceMappingURL=defaultValueRenderer.js.map